var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAzureinline = function SvgAzureinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.608 53.233c8.223-1.393 15.014-2.546 15.092-2.562l.142-.029-7.763-8.856c-4.27-4.87-7.763-8.874-7.763-8.897 0-.044 8.016-21.214 8.06-21.29.016-.025 5.47 9.008 13.224 21.896L63.9 55.602l.101.17-24.671-.003-24.671-.003 14.95-2.533ZM0 50.533c0-.013 3.658-6.103 8.129-13.534l8.128-13.51 9.473-7.624c5.21-4.194 9.487-7.63 9.504-7.636.017-.006-.052.16-.153.368l-10.286 21.16-10.102 20.78-7.347.009C3.306 50.551 0 50.545 0 50.532Z",
    fill: "currentColor"
  })));
};

export default SvgAzureinline;